import { useEffect } from 'react'
import { trackEvent } from '../lib/amplitude/trackEvent'
import { EventProps } from '../types/tracking'
import { useFirstMountState } from './useFirstMountState'

export const useTrackOnMount = ({ eventType, eventProperties }: EventProps) => {
  const isFirstMount = useFirstMountState()

  // Send event on first render
  useEffect(() => {
    if (isFirstMount) {
      trackEvent({ eventType, eventProperties })
    }
  }, [eventProperties, eventType, isFirstMount])
}
